import React, { useState } from "react";
import styled from "styled-components";

import { Typography, Box } from "@material-ui/core";
import SuggestForm from "../../pages/Listings/components/SuggestForm";
import { SocialPlatforms } from "../../constants/SocialPlatforms";
import { useMutation } from "@apollo/react-hooks";
import { createShow } from "../../graphql/mutations";
import { gql } from "apollo-boost";
import { roundTime } from "../../utils/time";

function Header() {
  const [showAdd, setShowAdd] = useState(false);
  const [onSave] = useMutation(gql(createShow));

  const submit = ({
    platform,
    user,
    time,
  }: {
    platform: SocialPlatforms;
    user: string;
    time: Date;
  }) => {
    onSave({
      variables: {
        input: {
          platform,
          username: user,
          timeStart: roundTime(time),
        },
      },
    })
      .then((res) => {
        setShowAdd(false);
      })
      .catch((err) => console.error(err));
  };

  const cancel = () => {
    setShowAdd(false);
  };
  return (
    <>
      <AppHeader>
        <header>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box display="flex" flexDirection="column">
              <Typography variant="h1" style={{ fontSize: "24px" }}>
                Who Streaming Live
              </Typography>
              <Typography variant="caption">
                The go to place to find when and where your favorite streamers
                are live
              </Typography>
            </Box>
            {/* <Box display="flex" id="" padding={1} alignItems="center">
              <Typography
                variant="caption"
                component="p"
                style={{ marginRight: "32px" }}
              >
                Don't see you or your favorite streamer on the schedule?
              </Typography>
              <Button
                onClick={() => setShowAdd(true)}
                style={{ color: "#ffffff" }}
              >
                Submit A Stream
              </Button>
            </Box> */}
          </Box>
        </header>
      </AppHeader>
      {showAdd && <SuggestForm submit={submit} cancel={cancel} />}
    </>
  );
}

export default Header;

const AppHeader = styled(Box)`
  background-color: ${(props) => props.theme.colors.grey.dark};
  color: #ffffff;
  padding: 8px 16px;
  header {
    align-items: center;
    display: flex;
    padding: 10px 0;

    .desktop-search {
      display: flex;
      flex-grow: 1;
      flex-basis: 100%;
      justify-content: flex-end;
      align-items: center;
      margin-left: 50px;

      .header-search {
        flex: 1;
      }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      justify-content: center;
      flex-wrap: wrap;
      .desktop-search {
        max-width: 100%;
        margin: 0;
      }
    }
  }
`;
